import { FC } from 'react';
import { Box, Link, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

export interface TextWithImageBlockProps {
  text: string;
  linkTitle?: string;
  link?: string;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    box: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(0, 7, 7),
    },
    text: {
      fontSize: '24px',
    },
    link: {
      color: 'rgba(36, 136, 228, 1)',
      textDecoration: 'underline !important',
      fontWeight: 700,
    },
  });
});

const TextBlockWithLink: FC<TextWithImageBlockProps> = (props) => {
  const { text, link, linkTitle } = props;
  const classes = useStyles();

  const renderTextWithLinks = (text: string) => {
    const parts = text.split(linkTitle).map((part, index, array) => (
      <>
        {part}
        {index < array.length - 1 && (
          <Link target={'_blank'} key={index} href={link} className={classes.link}>
            {linkTitle}
          </Link>
        )}
      </>
    ));

    return parts;
  };

  return (
    <Box pb={5} className={classes.box}>
      <Typography className={classes.text}>{renderTextWithLinks(text)}</Typography>
    </Box>
  );
};

export default TextBlockWithLink;
